"use client";

import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
export default function Legal() {
  const shouldReduceMotion = useReducedMotion();
  const baseTransition = shouldReduceMotion ? {
    duration: 0.2
  } : {
    duration: 0.7,
    ease: [0.22, 1, 0.36, 1] as [number, number, number, number]
  };
  const fadeUp = {
    hidden: {
      opacity: 0,
      y: shouldReduceMotion ? 0 : 16
    },
    show: {
      opacity: 1,
      y: 0
    }
  };
  const italicWordVariant = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: shouldReduceMotion ? {
        duration: 0.2
      } : {
        duration: 0.5,
        delay: 0.2,
        ease: [0.22, 1, 0.36, 1] as [number, number, number, number]
      }
    }
  };
  return <section data-section-id="28973" id="legalimportantnotice" data-nav="light" className="relative bg-background text-foreground py-32 md:py-44">
    {}
    <div aria-hidden="true" className="absolute top-0 inset-x-0 h-px" style={{
      backgroundColor: "var(--primary)"
    }} />

    <div className="mx-auto max-w-[780px] px-6 md:px-8 text-center">
      <motion.div initial="hidden" whileInView="show" viewport={{
        once: true,
        amount: 0.15
      }} transition={{
        staggerChildren: 0.12
      }}>
        {}
        <motion.p variants={fadeUp} transition={baseTransition} className="font-default uppercase text-[0.8rem]" style={{
          color: "var(--muted-foreground)",
          letterSpacing: "0.18em",
          fontWeight: 500,
          marginBottom: "40px"
        }}>
          重要な法的注意事項
        </motion.p>

        {}
        <motion.h2 variants={fadeUp} transition={baseTransition} className="font-serif text-foreground" style={{
          fontSize: "clamp(2.2rem, 4.6vw, 4rem)",
          fontWeight: 300,
          lineHeight: 1.08,
          letterSpacing: "-0.015em"
        }}>
          明確な判断のための{" "}
          <motion.span variants={italicWordVariant} className="font-serif italic inline-block" style={{
            color: "var(--primary)",
            fontWeight: 300
          }}>
            法律相談
          </motion.span>
          。
        </motion.h2>

        {}
        <motion.p variants={fadeUp} transition={baseTransition} className="font-default" style={{
          fontSize: "clamp(1.05rem, 1.2vw, 1.2rem)",
          lineHeight: 1.6,
          color: "var(--muted-foreground)",
          marginTop: "48px",
          fontWeight: 400
        }}>
          本ウェブサイトを通じてお問い合わせを送信しただけでは、弁護士と依頼者との関係は成立しません。
          当事務所では、ビジネス、不動産、Probate、信託関連、Attorney’s Fee Mattersに関する法律相談を提供しています。
          具体的なご相談内容については、当事務所までお問い合わせください。案件の内容を確認し、どのような対応が可能かをご案内いたします。
        </motion.p>

        {}
        <motion.div variants={fadeUp} transition={baseTransition} style={{
          marginTop: "56px"
        }}>
          <Link to="/ContactUsPage" className="group inline-flex items-baseline gap-2 font-default text-foreground transition-colors duration-200 hover:text-primary" style={{
            fontSize: "0.95rem",
            fontWeight: 500,
            textDecoration: "underline",
            textUnderlineOffset: "6px",
            textDecorationThickness: "1px",
            transition: "text-underline-offset 250ms ease, color 200ms ease"
          }}>
            <span className="tactile-link-text" style={{
              transition: "text-underline-offset 250ms ease"
            }}>
              当事務所へお問い合わせ
            </span>

            <span aria-hidden="true" className="transition-transform duration-300 group-hover:translate-x-1">
              →
            </span>
          </Link>
        </motion.div>
      </motion.div>
    </div>

    <style>{`
      #legalimportantnotice a:hover {
        text-underline-offset: 10px !important;
      }
    `}</style>
  </section>;
}